import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShoppingCartinline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 64 64",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("path", {
		id: "a",
		d: "M23.5697115,46.6153846 C26.17315,46.6153846 28.2836538,48.7258885 28.2836538,51.3293269 C28.2836538,53.9327654 26.17315,56.0432692 23.5697115,56.0432692 C20.9662731,56.0432692 18.8557692,53.9327654 18.8557692,51.3293269 C18.8557692,48.7258885 20.9662731,46.6153846 23.5697115,46.6153846 Z M53.28125,46.6153846 C55.8846884,46.6153846 57.9951923,48.7258885 57.9951923,51.3293269 C57.9951923,53.9327654 55.8846884,56.0432692 53.28125,56.0432692 C50.6778116,56.0432692 48.5673077,53.9327654 48.5673077,51.3293269 C48.5673077,48.7258885 50.6778116,46.6153846 53.28125,46.6153846 Z M23.5697115,48.6153846 C22.0708426,48.6153846 20.8557692,49.830458 20.8557692,51.3293269 C20.8557692,52.8281959 22.0708426,54.0432692 23.5697115,54.0432692 C25.0685805,54.0432692 26.2836538,52.8281959 26.2836538,51.3293269 C26.2836538,49.830458 25.0685805,48.6153846 23.5697115,48.6153846 Z M53.28125,48.6153846 C51.7823811,48.6153846 50.5673077,49.830458 50.5673077,51.3293269 C50.5673077,52.8281959 51.7823811,54.0432692 53.28125,54.0432692 C54.7801189,54.0432692 55.9951923,52.8281959 55.9951923,51.3293269 C55.9951923,49.830458 54.7801189,48.6153846 53.28125,48.6153846 Z M14.9038462,7 C15.342851,7 15.73052,7.28632253 15.8596252,7.70591415 L15.8596252,7.70591415 L18.8557692,16.9038462 L58.083728,16.9038462 C58.2986922,16.9038462 58.5122506,16.9385019 58.7161835,17.0064796 C59.7640701,17.3557751 60.3303901,18.4884151 59.9810946,19.5363017 L59.9810946,19.5363017 L53.2198766,39.8199555 C52.9476485,40.6366398 52.1833708,41.1875 51.32251,41.1875 L51.32251,41.1875 L25.546267,41.1875 C24.6682573,41.1875 23.8929192,40.6148549 23.6347089,39.7756717 L23.6347089,39.7756717 L14.1652715,9 L4,9 L4,7 Z M58.083728,18.9038462 L19.3051427,18.9038462 L25.546267,39.1875 L51.32251,39.1875 L58.083728,18.9038462 Z"
	}) }), /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("mask", {
				id: "b",
				fill: "#fff",
				children: /* @__PURE__ */ _jsx("use", { xlinkHref: "#a" })
			}),
			/* @__PURE__ */ _jsx("use", {
				fill: "#000",
				fillRule: "nonzero",
				xlinkHref: "#a"
			}),
			/* @__PURE__ */ _jsx("g", {
				fill: "#161719",
				mask: "url(#b)",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 24,
					height: 24
				})
			})
		]
	})]
});
export default SvgShoppingCartinline;
